<template>
  <div>
    <div v-if="visible">
      <div class="row items-center q-gutter-x-lg">
        <div
          v-if="price < regularPrice"
          class="self-stretch"
        >
          <div class="row flex-center bg-positive fit">
            <div class="text-h5 text-weight-medium q-px-sm text-green-2">
              {{ percent(((regularPrice - price) / regularPrice) * 100 * -1) }}
            </div>
          </div>
        </div>

        <div>
          <div class="column items-end">
            <div
              v-if="price < regularPrice"
              class="text-body1 text-weight-medium text-strike text-grey-6"
              style="line-height: normal"
            >
              {{ currency(regularPrice) }}
            </div>
            <div class="text-weight-medium price">
              {{ currency(price) }}
            </div>
          </div>
        </div>

        <q-separator
          v-if="product.unitPrice"
          vertical
        />

        <div v-if="product.unitPrice">
          <div class="column items-center">
            <div
              class="text-h6 text-weight-medium"
              style="line-height: 1"
            >
              {{ currency(product.unitPrice) }}
            </div>
            <div
              class="text-body2 text-weight-light"
              style="line-height: 1"
            >
              per
            </div>
            <div
              class="text-body2 text-weight-light"
              style="line-height: 1"
            >
              {{ product.isAmmunition ? 'round' : 'unit' }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-else
      class="row items-center q-gutter-sm"
    >
      <q-btn
        v-if="product.minimumAdvertisedPricePolicy === 'Click'"
        :label="cta"
        color="accent"
        size="lg"
        padding="sm lg"
        outline
        @click="visible = true"
      />

      <div
        v-else
        class="text-h5 text-accent text-weight-medium"
      >
        {{ cta }}
      </div>

      <q-btn
        :icon="mdiHelp"
        color="accent"
        flat
        round
        @click="onHelpClick"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { mdiHelp } from '@quasar/extras/mdi-v7';

const { product, variation, quoted } = useProduct()!;
const { currency, percent } = useFormatting();
const visible = ref<boolean>(!product.minimumAdvertisedPricePolicy || quoted.value);
const { mapDialog } = useDialogs();

const price = computed(() => variation.value?.price ?? product.price);

const regularPrice = computed(() => variation.value?.regularPrice ?? product.regularPrice);

const cta = computed(() => {
  switch (product.minimumAdvertisedPricePolicy) {
    case 'Click':
      return 'Click to See Price';
    case 'AddToCart':
      return 'See Price In Cart';
    case 'Checkout':
      return 'Checkout for Price';
    case 'Email':
      return 'Email for Price';
    default:
      return 'Price Unavailable';
  }
});

const onHelpClick = () => {
  if (product.minimumAdvertisedPricePolicy == null) {
    return;
  }

  mapDialog(product.minimumAdvertisedPricePolicy);
};
</script>

<style lang="scss" scoped>
@use "sass:map";

.price {
  font-size: map.get($h5, 'size');
  // line-height: map.get($h5, 'line-height');
  line-height: normal;

  @media (min-width: $breakpoint-md-min) {
    font-size: map.get($h4, 'size');
    // line-height: map.get($h4, 'line-height');
    line-height: 1;
  }
}

.placeholder {
  font-size: map.get($h4, 'size');

  @media (min-width: $breakpoint-md-min) {
    font-size: map.get($h3, 'size');
  }
}
</style>
